<template>
  <div>
    <div class="form-section">
      <h4 class="member-details-form-section-header">Eligibility information</h4>
      <!-- <Alert :message="this.errorMessaging.upcomingEligibilityExpiryAlert" v-if="showUpcomingExpiryAlert" />
      <Alert :alertType="`error`" :message="this.errorMessaging.convertedEligiblityAlert" v-if="showConvertedEligiblityAlert" />
      <Alert :alertType="`error`" :message="this.errorMessaging.expiredEligiblityAlert" v-if="showADFDeclarationExpiredAlert" /> -->

      <FormField>
        <div v-html="refData[updateMode ? 'eligibilityEditingInformationText' : 'eligibilityInformationText'].informationText"></div>
        <!-- <a id="toggleEdit" @click="switchMode">{{ updateMode ? backToReadViewBtnLabel : 'Change my eligibility' }}</a> -->
      </FormField>
    </div>

    <!-- read only view -->
    <div v-if="!updateMode" class="form-section">
      <FormField>
        <div class="eligibility-details-container">
          <div v-if="!isEmptyString(iCanJoinDisplayText)">
            <span>I can join Defence Health because</span>
            <p>{{ sentenceCase(iCanJoinDisplayText) }}</p>
          </div>
          <div v-if="!isEmptyString(eligibility.eligibilitySubject)">
            <span>{{ eligibilitySubjectLabel }}</span>
            <p>{{ sentenceCase(eligibility.eligibilitySubject) }}</p>
          </div>

          <div v-if="eligibility.eligibilitySubject.toLowerCase() === 'partner' && !isEmptyString(eligibility.subjectName)">
            <span>{{ thisEligibilityType === AcceptableThisEligibilityType.EX_SERVING ? 'Veteran' : 'Partner' }}'s name</span>
            <p>{{ sentenceCase(eligibility.subjectName) }}</p>
          </div>

          <!-- show only if supporting -->
          <template v-if="thisEligibilityType === AcceptableThisEligibilityType.RELATED">
            <div v-if="!isEmptyString(eligibility.subjectRelation)">
              <span>The person who serves/served is my</span>
              <p>{{ sentenceCase(eligibility.subjectRelation) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.workConnectionName)">
              <span>Name of connected individual</span>
              <p>{{ sentenceCase(eligibility.workConnectionName) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.subjectEligibilityType)">
              <span>How are they eligible?</span>
              <p>{{ sentenceCase(eligibility.subjectEligibilityType) }}</p>
            </div>
          </template>

          <!-- show only if ADF or Ex serving or Supporting with related person is currently serving/ex serving -->
          <template v-if="[...Eligibility.SERVING, ...Eligibility.EX_SERVING, ...Eligibility.RELATED].includes(thisEligibilityType) && !isContractorOrDefencePublicService">
            <div v-if="!isEmptyString(eligibility.subjectRank)">
              <span>Rank</span>
              <p>{{ sentenceCase(eligibility.subjectRank) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.subjectDepartmentOrCompanyName)">
              <span v-if="thisEligibilityType === AcceptableThisEligibilityType.RELATED">
                They serve{{ eligibility.subjectEligibilityType === 'Ex-serving' ? 'd' : '' }} in the
              </span>
              <span v-else>I/My partner serve{{ isServing ? '' : 'd' }} in the</span>
              <p>{{ sentenceCase(eligibility.subjectDepartmentOrCompanyName) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.subjectServiceType)">
              <span v-if="thisEligibilityType === AcceptableThisEligibilityType.RELATED">
                Their service {{ eligibility.subjectEligibilityType === 'Ex-serving' ? 'was' : 'is' }}
              </span>
              <span v-else>My/My Partner's service {{ isServing ? 'is' : 'was' }}</span>
              <p>{{ sentenceCase(eligibility.subjectServiceType) }}</p>
            </div>
          </template>

          <!-- show only if work connection -->
          <div v-if="thisEligibilityType === AcceptableThisEligibilityType.WORK_CONNECTION && !isEmptyString(eligibility.subjectEligibilityType)">
            <span>I/my partner worked for</span>
            <p>{{ sentenceCase(eligibility.subjectEligibilityType) }}</p>
          </div>

          <!-- show only if supporting and related person is contractor or defence public service or work connection-->
          <div
            v-if="
              (thisEligibilityType === AcceptableThisEligibilityType.RELATED && isContractorOrDefencePublicService) ||
              thisEligibilityType === AcceptableThisEligibilityType.WORK_CONNECTION
            "
          >
            <span>{{ eligibility.subjectEligibilityType.toLowerCase() === 'contractor' ? 'Company' : 'Department' }} name</span>
            <p>{{ sentenceCase(eligibility.subjectDepartmentOrCompanyName) }}</p>
          </div>

          <!-- if ADF or Ex serving-->
          <template v-if="thisEligibilityType === AcceptableThisEligibilityType.SERVING || thisEligibilityType === AcceptableThisEligibilityType.EX_SERVING">
            <div v-if="!isEmptyString(eligibility.enlistmentDate)">
              <span>Date of enlistment</span>
              <p>{{ reverseFormatFormDate(eligibility.enlistmentDate) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.dischargeDate) && !isServing">
              <span>Date of discharge</span>
              <p>{{ reverseFormatFormDate(eligibility.dischargeDate) }}</p>
            </div>
            <div v-if="!isEmptyString(eligibility.sercatStatus) && isServing">
              <span>SERCAT status - 3, 4, 5, 6 or 7</span>
              <p>SERCAT {{ eligibility.sercatStatus }}</p>
            </div>
          </template>

          <!-- if work connection -->
          <div v-if="!isEmptyString(eligibility.workConnectionName) && thisEligibilityType === AcceptableThisEligibilityType.WORK_CONNECTION">
            <span>Name of person with work connection</span>
            <p>{{ sentenceCase(eligibility.workConnectionName) }}</p>
          </div>
        </div>
      </FormField>
    </div>

    <!-- edit view -->
    <template v-else>
      <div class="form-section">
        <FormField labelText="I can join Defence Health because">
          <ul class="radio-group large">
            <li v-for="(option, index) in refData.needsAnalysisEligibilityOptions" :key="`eligibilityType${index}`">
              <input type="radio" :id="option.returnValue" :value="option.returnValue" v-model="thisEligibilityType" />
              <label :for="option.returnValue">{{ option.display }}</label>
            </li>
          </ul>
          <div v-if="!isEligibilityValidForProduct">
            <Alert v-if="currentMembership.accessLevel.toLowerCase() === AccessLevel.POLICY_HOLDER_ACCESS" alertType="error">
              <p>
                Based on the current product you are on, you are unable to make this change to your eligibility. If you would like to make this change to your eligibility,
                <router-link :to="{ name: CHANGE_MY_COVER }">change your product</router-link>
                .
              </p>
            </Alert>
            <Alert
              v-else
              message="Based on the current product you are on, you are unable to make this change to your eligibility. If you would like to make this change to your eligibility, please ask your policy holder to change your product."
              alertType="error"
            />
          </div>
        </FormField>
      </div>

      <EligibilityForm
        v-if="isEligibilityValidForProduct"
        :refData="refData"
        :formData="formatEligibilityDetails"
        :eligibilityType="thisEligibilityType"
        @responseUpdated="responseUpdated"
        :fileRequired="false"
        :contactIdOrMemberNumber="currentPolicyNumber"
        :coverStartDate="getCurrentDate()"
      />

      <div class="form-section">
        <FormField>
          <a id="disableEdit" @click="switchMode">{{ backToReadViewBtnLabel }}</a>
        </FormField>
      </div>
    </template>

    <!-- Update Annual Eligibility -->
    <div v-if="this.eligibilityType === AcceptableThisEligibilityType.SERVING && !updateMode" class="form-section">
      <FormField>
        <h3 class="h6 sub-heading-underlined">Annual eligibility declaration</h3>
        <div class="eligibility-details-container">
          <div v-if="!isEmptyString(eligibility.declarationDate)">
            <span>Eligibility declaration date</span>
            <p>{{ reverseFormatFormDate(eligibility.declarationDate) }}</p>
          </div>
          <div v-if="!isEmptyString(eligibility.expiryDate)">
            <span>ADF declaration expiry date</span>
            <p>{{ reverseFormatFormDate(eligibility.expiryDate) }}</p>
          </div>
        </div>
      </FormField>

      <AnnualEligibilityDeclaration
        v-if="updateAnnualDeclarationMode"
        :memberNumber="currentPolicyNumber"
        :initialData="{
          declarationDate: this.initialData.eligibility.declarationDate,
          expiryDate: this.initialData.eligibility.expiryDate,
        }"
        @updatedAnnualDeclaration="annualDeclarationUpdated"
      />

      <!-- <a id="toggleAnnualDeclaration" v-if="!updateMode" @click="switchAnnualDeclarationMode">
        {{ updateAnnualDeclarationMode ? 'Cancel annual eligibility declaration' : 'Update annual eligibility declaration' }}
      </a> -->
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { AcceptableThisEligibilityType, EligibilityTypes, UpdateMemberDetailsStepNames } from '@/enums';
import { reverseFormatFormDate, convertISOToDisplay, formatFormDate, isEmptyString, getCurrentDate, isWithinNdays, isPastDateExcludingToday } from '@general/js/utils';
import EligibilityForm from '@general/js/templates/JoinNow/JoinNowSteps/FormSection/EligibilityForm.vue';
import { mapEligibility } from '@general/js/utils/JoinNow/CreateMembershipUtils';
import { ProductTypeCodes } from '@general/js/enums';
import { EXCESS_CODE_MAPPING } from '@/constants/ProductExcessConstants';
import { CHANGE_MY_COVER } from '@/router/routeNames';
import { Alert } from '@/components/index';
import MemberDetailsMixin from './MemberDetailsMixin';
import AnnualEligibilityDeclaration from './AnnualEligibilityDeclaration.vue';

export default {
  setup() { return { v$: useVuelidate() }; },

  name: UpdateMemberDetailsStepNames.step4,

  mixins: [MemberDetailsMixin],

  components: {
    EligibilityForm,
    AnnualEligibilityDeclaration,
    Alert,
  },

  props: {
    initialData: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      backToReadViewBtnLabel: 'Remove changes to my eligibility',
      updateMode: false,
      isFormInvalid: false,
      eligibilityType: '',
      Eligibility: EligibilityTypes,
      AcceptableThisEligibilityType,
      updateAnnualDeclarationMode: false,
      isAnnualDeclarationInvalid: false,
      errorMessaging: {
        upcomingEligibilityExpiryAlert: 'You are required to update your annual eligibility requirements, please fill out your annual declaration.',
        convertedEligiblityAlert:
          'You have not updated your annual eligibility requirements by the required date. Please fill out your annual declaration, if you are no longer serving, please add your discharge date.',
        expiredEligiblityAlert:
          'You have not updated your annual eligibility requirements by the required date. Please fill out your annual declaration and upload the required evidence. Please note, this change could impact your product.',
      },
      CHANGE_MY_COVER,
    };
  },

  validations() {
    // Removing validation to mask eligiblity form
    // return this.validationObj;
    return true;
  },

  mounted() {
    this.eligibilityType = this.memberDetails?.eligibility?.eligibilityType ?? '';
    this.declarationDate = this.memberDetails?.eligibility?.declarationDate ?? '';
    this.expiryDate = this.memberDetails?.eligibility?.expiryDate ?? '';
  },

  computed: {
    iCanJoinDisplayText() {
      const selectedEligibility = this.refData.needsAnalysisEligibilityOptions.find((option) => {
        return option.returnValue === this.thisEligibilityType;
      });

      return selectedEligibility ? selectedEligibility.display : '';
    },

    thisEligibilityType: {
      get() {
        if (this.Eligibility.SERVING.includes(this.eligibilityType)) {
          return AcceptableThisEligibilityType.SERVING;
        }

        if (this.Eligibility.EX_SERVING.includes(this.eligibilityType)) {
          return AcceptableThisEligibilityType.EX_SERVING;
        }

        if (this.Eligibility.RELATED.includes(this.eligibilityType)) {
          return AcceptableThisEligibilityType.RELATED;
        }

        if (this.Eligibility.WORK_CONNECTION.includes(this.eligibilityType)) {
          return AcceptableThisEligibilityType.WORK_CONNECTION;
        }

        return '';
      },

      set(newVal) {
        this.eligibilityType = newVal;
      },
    },

    isContractorOrDefencePublicService() {
      return ['contractor', 'defence public service'].includes(this.eligibility.subjectEligibilityType.toLowerCase());
    },

    isServing() {
      return this.thisEligibilityType === AcceptableThisEligibilityType.SERVING;
    },

    // if `updateMode` or `updateAnnualDeclarationMode` is false, there is no validation
    validationObj() {
      // adding member details with any validation rule for making sure `v$.memberDetails.$model` is accessible for watcher in `MemberDetailsMixin` and does not update `memberDetails` to `undefined`
      const obj = {
        memberDetails: {},
        showConvertedEligiblityAlert: {
          value(bool) {
            return bool === false;
          },
        },
        showADFDeclarationExpiredAlert: {
          value(bool) {
            return bool === false;
          },
        },
      };

      if (this.updateMode) {
        obj.eligibilityType = { required };
        obj.isFormInvalid = {
          isValid(bool) {
            return bool === false;
          },
        };
        obj.isEligibilityValidForProduct = {
          isValid(bool) {
            return bool === true;
          },
        };
      }

      if (this.updateAnnualDeclarationMode) {
        obj.isAnnualDeclarationInvalid = {
          isValid(bool) {
            return bool === false;
          },
        };
      }
      return obj;
    },

    eligibility() {
      return this.memberDetails.eligibility;
    },

    isInitialEligibilityType() {
      return this.initialData.eligibility.eligibilityType === this.eligibilityType;
    },

    // match eligibility details data object to right structure for <EligibilityForm> component can consume
    formatEligibilityDetails() {
      const data = this.initialData.eligibility;
      const obj = {
        serviceConnection: this.isInitialEligibilityType ? data.eligibilitySubject : '',
        serviceConnectionName: this.isInitialEligibilityType ? data.subjectName : '',
        declaration: this.isInitialEligibilityType ? data.declarationIsConfirmed : false,
      };

      switch (this.thisEligibilityType) {
        case this.AcceptableThisEligibilityType.SERVING:
          obj.declaration = false; // in edit mode, declaration is always false
          obj.subFormData = {
            enlistmentDate: isEmptyString(data.enlistmentDate) || !this.isInitialEligibilityType ? '' : reverseFormatFormDate(data.enlistmentDate),
            sercatStatus: this.isInitialEligibilityType ? data.sercatStatus.replace('SERCAT ', '') : '',
            sercatFileNames: [],
            veteranInfo: {
              rank: this.isInitialEligibilityType ? data.subjectRank : '',
              serviceAgency: this.isInitialEligibilityType ? data.subjectDepartmentOrCompanyName : '',
              serviceType: this.isInitialEligibilityType ? data.subjectServiceType : '',
            },
          };
          break;

        case this.AcceptableThisEligibilityType.EX_SERVING:
          obj.declaration = false; // in edit mode, declaration is always false
          obj.subFormData = {
            enlistmentDate: isEmptyString(data.enlistmentDate) || !this.isInitialEligibilityType ? '' : reverseFormatFormDate(data.enlistmentDate),
            dischargeDate: isEmptyString(data.dischargeDate) || !this.isInitialEligibilityType ? '' : reverseFormatFormDate(data.dischargeDate),
            veteranInfo: {
              rank: this.isInitialEligibilityType ? data.subjectRank : '',
              serviceAgency: this.isInitialEligibilityType ? data.subjectDepartmentOrCompanyName : '',
              serviceType: this.isInitialEligibilityType ? data.subjectServiceType : '',
            },
          };
          break;

        case this.AcceptableThisEligibilityType.RELATED:
          obj.subFormData = {
            relationName: this.isInitialEligibilityType ? data.workConnectionName : '',
            relationship: this.isInitialEligibilityType ? data.subjectRelation : '',
            connectionName: this.isInitialEligibilityType ? data.subjectDepartmentOrCompanyName : '',
            connectionType: this.isInitialEligibilityType ? data.subjectEligibilityType : '',
            veteranInfo: {
              rank: this.isInitialEligibilityType ? data.subjectRank : '',
              serviceAgency: this.isInitialEligibilityType ? data.subjectDepartmentOrCompanyName : '',
              serviceType: this.isInitialEligibilityType ? data.subjectServiceType : '',
            },
          };
          break;

        default:
          obj.subFormData = {
            relationName: this.isInitialEligibilityType ? data.workConnectionName : '',
            connectionName: this.isInitialEligibilityType ? data.subjectDepartmentOrCompanyName : '',
            connectionType: this.isInitialEligibilityType ? data.subjectEligibilityType : '',
          };
          break;
      }

      return obj;
    },

    eligibilitySubjectLabel() {
      switch (this.thisEligibilityType) {
        case this.AcceptableThisEligibilityType.SERVING:
          return 'Who is currently serving?';

        case this.AcceptableThisEligibilityType.EX_SERVING:
          return 'Who served?';

        case this.AcceptableThisEligibilityType.WORK_CONNECTION:
          return 'Who had/has a work connection to the Defence or a Defence -related government department?';

        case this.AcceptableThisEligibilityType.RELATED:
          return 'Who is related to the person who serves/served?';

        default:
          return '';
      }
    },

    showUpcomingExpiryAlert() {
      // ADF Declaration expiry is within `DAYS` days
      const DAYS = 14;
      return this.eligibilityType === AcceptableThisEligibilityType.SERVING && isWithinNdays(getCurrentDate(), this.memberDetails.eligibility.expiryDate, DAYS);
    },

    showConvertedEligiblityAlert() {
      // OHI has converted 'Serving' -> 'Ex-serving', clears dischargeDate and the user isn't modifying the data
      return this.eligibilityType === AcceptableThisEligibilityType.EX_SERVING && !this.memberDetails.eligibility.dischargeDate && !this.updateMode;
    },

    showADFDeclarationExpiredAlert() {
      // ADF Declaration expiry date is past but OHI hasn't converted eligibility
      return this.eligibilityType === AcceptableThisEligibilityType.SERVING && isPastDateExcludingToday(reverseFormatFormDate(this.memberDetails.eligibility.expiryDate));
    },

    isEligibilityValidForProduct() {
      // Returns true if the eligibility is valid for the current product and excess combination
      const hospitalProduct = this.coverDetails.products.find((product) => {
        return product.productTypeCode === ProductTypeCodes.HOSPITAL_ONLY || product.productTypeCode === ProductTypeCodes.PACKAGE;
      });

      if (hospitalProduct) {
        const mappedEligibilitySegment = EXCESS_CODE_MAPPING.find((segment) => {
          return segment.value.includes(this.thisEligibilityType);
        })?.code;

        const excess = hospitalProduct.productExcess.some((productExcess) => {
          return productExcess.eligibilitySegment.split(',').includes(mappedEligibilitySegment) && productExcess.excess === this.coverDetails.membership.excess;
        });

        return excess;
      }
      // No hospital product, so no eligibilities to validate
      return true;
    },
  },

  methods: {
    sentenceCase(str) {
      if (str.length > 0) {
        return str[0].toUpperCase() + str.slice(1);
      }

      return str;
    },

    responseUpdated(res, invalid) {
      this.isFormInvalid = invalid;

      const newData = {
        ...this.memberDetails,
        eligibility: {
          ...mapEligibility(res, this.eligibilityType),
          sercatFileNames: res.subFormData.sercatFileNames,
        },
      };

      /**
       * format keys/data that are not matching with data structure
       */
      // format date data to match with initial return data format from api
      const enlistmentDate = newData.eligibility.enlistmentDate;
      const dischargeDate = newData.eligibility.dischargeDate;

      if (enlistmentDate !== '') {
        newData.eligibility.enlistmentDate = formatFormDate(convertISOToDisplay(enlistmentDate));
      }

      if (dischargeDate !== '') {
        newData.eligibility.dischargeDate = formatFormDate(convertISOToDisplay(dischargeDate));
      }

      // making sure all undefined data are empty string for structure consistency
      Object.keys(newData.eligibility).forEach((key) => {
        if (newData.eligibility[key] === undefined) {
          newData.eligibility[key] = '';
        }
      });

      // update vuex
      this.updateMemberDetails(newData);
    },

    switchMode() {
      this.updateMode = !this.updateMode;

      if (!this.updateMode) {
        // update data back to initial data
        this.eligibilityType = this.initialData.eligibility.eligibilityType;
        this.isFormInvalid = false;

        this.updateMemberDetails({
          ...this.memberDetails,
          eligibility: {
            ...this.initialData.eligibility,
          },
        });
      }
    },

    switchAnnualDeclarationMode() {
      this.updateAnnualDeclarationMode = !this.updateAnnualDeclarationMode;

      if (!this.updateAnnualDeclarationMode) {
        this.isAnnualDeclarationInvalid = false;

        this.updateMemberDetails({
          ...this.memberDetails,
          eligibility: {
            ...this.initialData.eligibility,
          },
        });
      }
    },

    annualDeclarationUpdated(res, invalid) {
      this.isAnnualDeclarationInvalid = invalid;

      const newData = {
        ...this.memberDetails,
        eligibility: {
          ...this.memberDetails.eligibility,
          declarationDate: res.declarationDate,
          expiryDate: res.expiryDate,
          sercatFileNames: res.sercatFileNames,
          declarationIsConfirmed: res.declarationIsConfirmed,
        },
      };

      this.updateMemberDetails(newData);
    },

    reverseFormatFormDate,
    isEmptyString,
  },
};
</script>

<style lang="scss" scoped>
.eligibility-details-container {
  @include flex-col;
  gap: 2rem;

  > div {
    span {
      font-weight: $BOLD;
    }

    p {
      margin-block: auto;
      margin-top: 0.5rem;
    }
  }
}
</style>
